export default __webpack_public_path__ + "static/media/MobileLandingPage.136916f7.svg";